module.exports = __webpack_public_path__ + "img/bluesky34.6269bee1.jpg";